<div
  ngpRangeSlider
  class="wrapper"
  [class.is-disabled]="isDisabled()"
  [class.is-invalid]="errorState"
  [attr.aria-invalid]="errorState ? 'true' : null"
  [ngpRangeSliderLow]="low"
  [ngpRangeSliderHigh]="high"
  [ngpRangeSliderMin]="min"
  [ngpRangeSliderMax]="max"
  [ngpRangeSliderStep]="step"
  [ngpRangeSliderDisabled]="isDisabled()"
  (ngpRangeSliderLowChange)="onLowChange($event)"
  (ngpRangeSliderHighChange)="onHighChange($event)"
>
  <div ngpRangeSliderTrack class="track">
    <div ngpRangeSliderRange class="range"></div>
    <div ngpRangeSliderThumb ngpFocus class="thumb" [id]="effectiveId"></div>
    <div ngpRangeSliderThumb ngpFocus class="thumb"></div>
  </div>
</div>
